<template>
  <div class="layout" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: absolute; left: 80px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <el-row :gutter="10" style="margin-top: 40px;">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin-bottom: 25px;">
        <div style="font-size: 17px;">腳本類型說明</div><hr/>
        <div class="contain2" v-for="(model, index) in models" :key="index" @click="getModel(model)">
          <div style="font-width: 500; font-size: 20px; text-align: left;">
            <mu-icon size="24" value="insert_drive_file" style="transform: translateY(3px); margin-right: 10px;"></mu-icon>
            <span style="font-weight: 500;">{{ model.title }}</span>
            <hr style="border: 1px solid #eee;"/>
            <div style="font-size: 15px; margin-top: 12px;">1. 總共<span style="font-weight: 500; color: #3599fc"> {{ model.num }}</span> 則腳本訊息</div>
            <div style="font-size: 15px; margin-top: 12px;">2. {{ model.restrain }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="contain">
          <div style="padding: 0 0 10px 0; text-align: left;">
            <el-button type="danger" size="small" @click="deleteItem">刪除</el-button>
          </div>
          <mu-data-table selectable select-all :selects.sync="selects" checkbox :columns="columns" :data="list" style="width: 100%;" @row-click="getRow" no-data-text="尚無使用中的腳本">
            <template slot-scope="scope">
              <td>{{scope.row[0]}}</td>
              <td>{{scope.row[1].Type}}</td>
              <td><mu-icon size="20" value="create" style="transform: translateY(2px);"></mu-icon></td>
            </template>
          </mu-data-table>
          <div style="text-align: left; margin-top: 10px;">
            <mu-icon size="24" value="notifications_none" style="transform: translateY(3px); margin-right: 5px;"></mu-icon>
            <span style="font-size: 15px;">每個帳號有兩組免費<span style="font-weight: 500;"> 進階腳本</span>，如有額外需求可加購</span>
          </div>
          <div style="margin-top: -35px; text-align: right; position: absolute; right: -5px; bottom: -17px;">
            <mu-button fab color="blue" style="transform: scale(0.7);" @click="addScript">
              <mu-icon value="add" size="35"></mu-icon>
            </mu-button>
          </div>
        </div>
      </el-col>
      <!-- 刪除腳本 -->
      <el-dialog :visible="openDelete" width="700px" :show-close="false">
        <div style="font-size: 16px;">確定要刪除這些腳本嗎？刪除後將無法復原</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="openDelete = false">取 消</el-button>
          <el-button type="primary" @click="sendDelete">確 定</el-button>
        </span>
      </el-dialog>
      <!-- 新增腳本 -->
      <el-dialog :visible="openDia" width="700px" :show-close="false">
        <!-- 類型 -->
        <div v-if="step !== 2">
          <el-radio v-model="radio1" label="基礎腳本 A" border>基礎腳本 A</el-radio>
          <el-radio v-model="radio1" label="基礎腳本 B" border>基礎腳本 B</el-radio>
          <el-radio v-model="radio1" label="進階腳本 A" border :disabled="hasAdvanceA">進階腳本 A</el-radio>
          <el-radio v-model="radio1" label="進階腳本 B" border :disabled="hasAdvanceB">進階腳本 B</el-radio>
        </div>
        <!-- 名稱 -->
        <div v-if="radio1 !== '' && step === 2">
          <el-input placeholder="請輸入內容" v-model="scriptContent.ScriptName">
            <template slot="prepend">觸發關鍵字</template>
          </el-input>
          <!-- 卡片 -->
          <el-carousel trigger="click" height="280px" style="overflow: hidden;" :autoplay="false" arrow="always">
            <el-carousel-item v-for="(item, idx) in cardNum" :key="idx + 'n'">
              <div class="cardbox">
                <h4 style="margin-top: 0; margin-bottom: 10px;">
                  <mu-icon size="24" value="mms" style="transform: translateY(3px); margin-right: 5px;"></mu-icon>
                  腳本回覆 {{item}}
                </h4>
                <!-- 卡片類型 -->
                <div style="margin-top: 5px; display: inline-block; margin-right: 5px;" v-if="radio1 === '進階腳本 A' || radio1 === '進階腳本 B'">
                  <div style="margin-bottom: 5px; font-weight: 500; font-size: 15px;">卡片類型:</div>
                  <el-select @change="getCurrentType(idx)" v-if="service === 'LINE'" v-model="cardType[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in typeListLINE"
                      :key="index + 't'"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select @change="getCurrentType(idx)" v-if="service === 'FB'" v-model="cardType[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in typeListFB"
                      :key="index + 't'"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 卡片類型 -->
                <div style="margin-top: 5px; display: inline-block; margin-right: 5px;" v-else>
                  <div style="margin-bottom: 5px; font-weight: 500; font-size: 15px;">卡片類型:</div>
                  <el-select @change="getCurrentType(idx)" v-if="service === 'LINE'" v-model="cardType[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in typeListLINE2"
                      :key="index + 't'"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select @change="getCurrentType(idx)" v-if="service === 'FB'" v-model="cardType[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in typeListFB2"
                      :key="index + 't'"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 卡片名稱 -->
                <div style="display: inline-block;">
                  <div style="margin-bottom: 5px; font-weight: 500; font-size: 15px;">卡片名稱:</div>
                  <el-select v-model="cardArr[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in cardList[idx]"
                      :key="index + 'c'"
                      :label="item.name"
                      :value="JSON.stringify(item)">
                    </el-option>
                  </el-select>
                </div>
                <!-- 藍色選單 -->
                <div style="margin-top: 15px; display: inline-block; margin-right: 5px;">
                  <div style="margin-bottom: 5px; font-weight: 500; font-size: 15px;">藍色選單:</div>
                  <el-select v-model="blueArr[idx]" placeholder="請選擇" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in blueMenu"
                      :key="index + 'b'"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
                <!-- 延遲時間 -->
                <div style="display: inline-block;">
                  <div style="margin-bottom: 5px; font-weight: 500; font-size: 15px;">延遲時間:</div>
                  <el-input style="width: 90px; margin-right: 5px;" v-model="intervalArr[idx]"></el-input>
                  <el-select v-model="unit[idx]" placeholder="請選擇" style="margin-right: 10px; width: 100px;">
                    <el-option v-for="(item, index) in unitList"
                      :key="index + 'u'"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div style="margin-top: 10px;">
                  延遲時間最多不能超過 <span style="font-weight: 600; color: #f24;">24 </span>小時
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 按鈕 -->
        <span slot="footer" class="dialog-footer">
          <span style="color: #f24;">{{ warning }}</span>
          <mu-button v-if="step === 2 && !noControll" flat color="primary" @click="preStep">上一步</mu-button>
          <mu-button v-if="step === 1 || noControll" flat color="primary" @click="openDia = false">返回</mu-button>
          <mu-button v-if="step === 1" color="primary" style="margin-left: 10px;" @click="nextStep">下一步</mu-button>
          <mu-button v-if="step === 2" color="primary" style="margin-left: 10px;" @click="checkData">完成</mu-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
/* eslint-disable */
export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      openDia: false,
      openDelete: false,
      noControll: false,
      hasAdvanceA: false,
      hasAdvanceB: false,
      pageLoading: false,
      step: 1,
      radio1: '基礎腳本 A',
      warning: '',
      deleteArray: [],
      cardArr: [],
      cardList: [],
      cardType: [],
      blueArr: [],
      intervalArr: [],
      unit: [],
      blueMenu: [],
      unitList: [
        { name: '秒鐘', value: 's' },
        { name: '分鐘', value: 'm' },
        { name: '小時', value: 'h' }
      ],
      typeListLINE2: [
        { name: '全部', value: 'all' },
        { name: '文字訊息', value: 'text' },
        { name: '文字卡片', value: 'flex_01' },
      ],
      typeListLINE: [
        { name: '全部', value: 'all' },
        { name: '文字訊息', value: 'text' },
        { name: '文字卡片', value: 'flex_01' },
        { name: '圖片卡片', value: 'image_carousel' },
        { name: '網頁卡片', value: 'flex' },
        { name: '直向卡片', value: 'stream'}
      ],
      typeListFB: [
        { name: '全部', value: 'all' },
        { name: '文字訊息', value: 'Message' },
        { name: '文字卡片', value: 'MessageCard' },
        { name: '網頁卡片', value: 'WebCard' },
        { name: '橫向卡片', value: 'BoxCard'},
        { name: '直向卡片', value: 'Stream'}
      ],
      typeListFB2: [
        { name: '全部', value: 'all' },
        { name: '文字訊息', value: 'Message' },
        { name: '文字卡片', value: 'MessageCard' }
      ],
      nowType: '',
      allCard: [
        {
          name: '圖片測試',
          cards: ['123']
        }
      ],
      scriptContent: {
        ScriptName: '',
        Content: []
      },
      models: [
        {
          title: '基礎腳本 A',
          num: 3,
          restrain: '限文字訊息、文字卡片',
        },
        {
          title: '基礎腳本 B',
          num: 4,
          restrain: '限文字訊息、文字卡片'
        },
        {
          title: '進階腳本 A',
          num: 3,
          restrain: '不限類型'
        },
        {
          title: '進階腳本 B',
          num: 4,
          restrain: '不限類型'
        },
      ],
      nowScripts: [],
      selects: [],
      columns: [
        { title: '觸發關鍵字', width: 190, name: 'name' },
        { title: '腳本類型', width: 140, name: 'type' },
        { title: '', width: 100, name: 'edit' }
      ],
      list: []
    };
  },
  computed: {
    ...mapGetters({
      workFlows: 'workFlows'
    }),
    cardNum() {
      return this.models.filter(el => el.title === this.radio1)[0].num;
    },
  },
  mounted() {
    this.getScripts();
    this.checkUsableCards(this.service);
    if (this.service === 'FB') {
      this.getBlue(this.auth).then((res) => {
        this.blueMenu = res.data;
      });
    }
    else {
      this.getBlueEach(this.auth).then((res) => {
        this.blueMenu = Object.keys(res);
      });
    }
  },
  methods: {
    ...mapActions({
      getAllWorkFlow: 'getAllWorkFlow',
      getAllWorkFlowLINE: 'getAllWorkFlowLINE',
      SetPageScript: 'SetPageScript',
      removeScript: 'removeScript',
      getScript: 'getScript',
      getBlue: 'getBlue',
      getBlueEach: 'getBlueEach'
    }),
    showFlashMessage(message, time) {
      this.$notify({
        title: '成功',
        message: message,
        type: 'success'
      });
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getModel(val) {
      this.radio1 = val.title;
      this.step = 2;
      this.openDia = true;
    },
    getCurrentType(index) {
      // this.nowType = this.cardType[index];
      this.cardArr[index] = '';

      if (this.service === 'FB') {
        if (this.radio1 === '基礎腳本 A' || this.radio1 === '基礎腳本 B') {
          if (this.cardType[index] === 'all') {
            this.cardList[index] = this.allCard.filter(el => el.type === 'Message' || el.type === 'MessageCard');
          }
          else {
            this.cardList[index] = this.allCard.filter(st => st.type === this.cardType[index]);
          }
        }
        else {
          if (nowType === 'all') {
            this.cardList[index] = this.allCard;
          }
          else {
            this.cardList[index] = this.allCard.filter(st => st.type === this.cardType[index] );
          }
        }
      }
      else {
        if (this.radio1 === '基礎腳本 A' || this.radio1 === '基礎腳本 B') {
          if (this.cardType[index] === 'all') {
            this.cardList[index] = this.allCard.filter(el => el.type === 'text' || el.type === 'flex_01');
          }
          else {
            this.cardList[index] = this.allCard.filter(st => st.type === this.cardType[index]);
          }
        }
        else {
          if (this.cardType[index] === 'all') {
            this.cardList[index] = this.allCard;
          }
          else {
            this.cardList[index] = this.allCard.filter(st => st.type === this.cardType[index]);
          }
        }
      }
    },
    sendDelete() {
      this.openDelete  = false;
      this.pageLoading = true;
      this.removeScript({ service: this.service, auth: this.auth, scriptNames: this.deleteArray })
        .then(() => {
          this.showFlashMessage('已刪除腳本模組', 1000);
          this.getScripts();
          this.pageLoading = false;
          this.selects     = [];
          this.deleteArray = [];
        })
    },
    deleteItem() {
      const deleteArr = [];
      for (let i = 0; i < this.selects.length; i += 1) {
        const idx = this.selects[i];
        deleteArr.push(this.list[idx][0])
      }
      this.deleteArray = deleteArr;
      this.openDelete = true;
    },
    getRow(row) {
      const rowData = this.list[row];
      const rowContent = rowData[1].Content;
      this.noControll = true;
      this.openDia = true;
      this.step = 2;
      this.radio1 = rowData[1].Type;
      this.scriptContent.ScriptName = rowData[0];
      this.cardType = rowContent.map(el => el.type);
      this.blueArr = rowContent.map(el => el.reply);
      this.unit = rowContent.map(el => el.unit);
      // 計算時間
      const unitVal = this.unit.map(st => st.replace('s', 1).replace('m', 60).replace('h', 3600));
      this.intervalArr = rowContent.map((el, idx) => el.interval / 1000 / parseInt(unitVal[idx]));
      for (let i = 0; i < rowContent.length; i += 1) {
        const index = i;
        this.getCurrentType(index);
        if (index === rowContent.length - 1) {
          this.cardArr = rowContent.map(el => el.cardCon);
        }
      }
    },
    getScripts() {
      this.getScript({ service: this.service, auth: this.auth }).then((res) => {
        if (res && res.data && res.data.List) {
          this.list = Object.entries(res.data.List);
          if (this.list.map(el => el[1].Type).indexOf('進階腳本 A') !== -1) {
            this.hasAdvanceA = true;
          }
          if (this.list.map(el => el[1].Type).indexOf('進階腳本 A') === -1) {
            this.hasAdvanceA = false;
          }
          if (this.list.map(el => el[1].Type).indexOf('進階腳本 B') !== -1) {
            this.hasAdvanceB = true;
          }
          if (this.list.map(el => el[1].Type).indexOf('進階腳本 B') === -1) {
            this.hasAdvanceB = false;
          }
        }
        else { this.list = [] }
      })
    },
    sendScript() {
      const unitScale = this.unit.map(el => el.replace('s', 1).replace('m', 60).replace('h', 3600));
      for (var i = 0; i < this.cardNum; i += 1) {
        this.scriptContent.Content[i] = {
          cardCon: this.cardArr[i],
          type: this.cardType[i],
          card: JSON.parse(this.cardArr[i]).cards,
          name: JSON.parse(this.cardArr[i]).name,
          reply: this.blueArr[i],
          interval: parseInt(this.intervalArr[i]) * 1000 * parseInt(unitScale[i]),
          unit: this.unit[i]
        }
      }
      this.pageLoading = true;
      this.SetPageScript({ service: this.service, auth: this.auth, type: this.radio1, scriptName: this.scriptContent.ScriptName, content: this.scriptContent.Content })
        .then(() => {
          this.openDia     = false;
          this.pageLoading = false;
          this.getScripts();
          this.showFlashMessage('已新增腳本模組', null);
        })
    },
    checkData() {
      if (!this.scriptContent.ScriptName || this.scriptContent.ScriptName  === '') {
        this.warning = '請輸入觸發關鍵字';
        return;
      }
      if (this.cardArr.length !== this.cardNum) {
        this.warning = '有腳本尚未選擇卡片哦!';
        return;
      }
      if (this.intervalArr.indexOf('') !== -1) {
        this.warning = '有腳本尚未填寫延遲時間哦!';
        return;
      }
      const usableInterval = this.intervalArr.map(el => parseInt(el));
      const unitScale = this.unit.map(el => el.replace('s', 1).replace('m', 60).replace('h', 3600));

      for (let i = 0; i < usableInterval.length; i += 1) {
        if ((i < (usableInterval.length - 1)) && ((usableInterval[i + 1] * parseInt(unitScale[i + 1])) - (usableInterval[i] * parseInt(unitScale[i])) < 120)) {
          this.warning = '每則腳本間隔至少 2 分鐘哦';
          return;
        }
        if (i === usableInterval.length - 1) {
          this.warning = '';
          this.sendScript();
        }
      }
    },
    getCardsType(payload) {
      const apiUrl = `https://api.eilis-ai.com/functional/GetPayload`;
      return this.axios.post(apiUrl, payload)
        .then(response => ({
          idx: payload.idx,
          type: response.data.Type,
        }));
    },
    getType(res) {
      if (res.data.Content && res.data.Content.template) {
        if (res.data.Content.template.type === 'carousel') {
          return 'Carousel template';
        }
        if (res.data.Content.template.type === 'image_carousel') {
          return 'image_carousel';
        }
      }
      if (res.data.CardType) {
        return 'flex_01';
      }
      return res.data.Content.type;
    },
    // 取得卡片類型
    getCardsTypeLINE(payload) {
      const apiUrl = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire';
      return this.axios.post(apiUrl, payload)
        .then(response => ({
          content: response.data,
          idx: (payload !== undefined) ? payload.idx : 0,
          type: this.getType(response),
        }));
    },
    checkUsableCards(service) {
      const workFlowList = this.workFlows[this.auth];
      if (service === 'FB') {
        if (workFlowList) {
          this.getAllWorkFlowLocal(workFlowList);
        }
        else {
          this.getAllWorkFlow(this.auth).then((res) => {
            if (res) {
              this.getAllWorkFlowLocal(res);
            }
          })
        }
      }
      else {
        if (workFlowList) {
          this.getWorkFlowLocalLINE(workFlowList);
        }
        else {
          this.getAllWorkFlowLINE(this.auth).then((res) => {
            if (res) {
              this.getWorkFlowLocalLINE(res);
            }
          })
        }
      }
    },
    // 取得所有卡片
    getWorkFlowLocalLINE(res) {
      const workflowName = [];
      const cardArray = Object.keys(res);
      for (let i = 0; i < cardArray.length; i += 1) {
        workflowName[i] = {
          cards: [Object.values(res)[i].CardID],
          name: Object.values(res)[i].KeyWord[0].replace('@$@', '').replace('#&#',''),
          type: '',
        }
      }
      this.allCard = workflowName;
      // 取得卡片類型
      this.allCard.map((el, idx) => {
        this.getCardsTypeLINE({
          Path: 'Eilis-Clients/',
          ChildPath: `${this.auth}/Card/${el.cards[0]}`,
          idx,
        }).then((resp) => {
          if (resp.type) {
            this.$set(this.allCard[resp.idx], 'type', resp.type);
          }
          else {
            this.$set(this.allCard[resp.idx], 'type', 'stream');
          }
        })
      })
    },
    getAllWorkFlowLocal(res) {
      const workflowName = [];
      const cardArray = Object.keys(res);
      for (let i = 0; i < cardArray.length; i += 1) {
        workflowName[i] = {
          name: Object.keys(res)[i].replace('@#@', ''),
          cards: Object.values(res)[i].Cards,
          reply: Object.values(res)[i].Reply ? Object.values(res)[i].Reply : '公版主選單',
          type: '',
          showType: Object.values(res)[i].ShowType
        }
      }
      this.allCard = workflowName;
      // 取得卡片類型
      this.allCard.map((el, idx) => {
        if (el.showType) {
          this.$set(this.allCard[idx], 'type', el.showType);
        }
        else {
          this.getCardsType({
            PageID: this.auth,
            CardID: el.cards.join(),
            idx
          }).then((resp) => {
            if (resp.type) {
              this.$set(this.allCard[idx], 'type', resp.type);
            }
            else {
              this.$set(this.allCard[idx], 'type', 'Stream');
            }
          })
        }
      })
    },
    addScript() {
      this.radio1 = '基礎腳本 A';
      this.step = 1;
      this.openDia = true;
      this.noControll = false;
      this.scriptContent.ScriptName = '';
      this.cardArr = [];
      this.blueArr = [];
    },
    nextStep() {
      if (this.radio1 === '') {
        return;
      }
      if (this.cardNum === 3) {
        this.intervalArr = ['', '', ''];
      }
      else {
        this.intervalArr = ['', '', '', ''];
      }
      this.step += 1;
    },
    preStep() {
      this.step -= 1;
    }
  }
}
</script>

<style scoped>
.layout {
  padding-left: 60px;
  min-width: 100%;
  max-width: 100%;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.layout-66 {
  border-radius: 6px;
  background: #ffffff;
  height: 500px;
  min-width: 66.6666%;
  max-width: 66.6666%;
  flex: 0 1 66.6666%;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
.icon {
  display: inline-block;
  margin-right: 8px;
  transform: translateY(2px);
}
.column {
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
  width: 90%;
  margin: 15px auto;
  text-align: left;
  cursor: pointer;
  transition: 0.3s;
}
.column:hover {
  transform: scale(1.05);
}
.layout-33 {
  height: 500px;
  background: #ffffff;
  min-width: 100px;
  max-width: 400px;
  flex: 0 1 33.3333%;
}
.cardbox {
  padding: 70px;
  padding-top: 20px;
  padding-bottom: 20px;
  border: 1px solid #eee;
  margin-top: 10px;
  text-align: left;
}
.contain {
  display: inline-block;
  position: relative;
}
.contain2:hover {
  transform: scale(1.05);
}
.contain2 {
  background-color: #fff;
  display: inline-block;
  box-shadow: 2px 2px 5px -1px rgba(20% ,20% ,40% ,0.5);
  padding: 23px 23px;
  width: 45%;
  border-radius: 5px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: 0.2s;
}
</style>